import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function IndeterminateCheckbox({
  indeterminate,
  className = '',
  label = '',
  ...rest
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <>
      <input
        id="default-checkbox"
        type="checkbox"
        ref={ref}
        {...rest}
        className={`w-4 h-4 accent-orange-600 rounded-[35%] cursor-pointer ${className}`}
      />
      {label && (
        <label
          htmlFor="default-checkbox"
          className="text-base font-medium text-gray-900 ms-2 dark:text-gray-300"
        >
          {label}
        </label>
      )}
    </>
  );
}

IndeterminateCheckbox.propTypes = {
  className: PropTypes.string,
  indeterminate: PropTypes.bool,
  label: PropTypes.string,
};

export default IndeterminateCheckbox;
